import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function PassCard({ passId, passcode, title, subtitle, lines = [], footer, variant = 'default' }) {
  const bg = variant === 'dark' ? 'bg-ink text-white' : 'bg-white';
  const border = variant === 'dark' ? 'border-white/20' : 'border-zinc-300';
  const text = variant === 'dark' ? 'text-white' : 'text-ink';
  const muted = variant === 'dark' ? 'text-white/60' : 'text-zinc-500';

  return (
    <div className={`relative ${bg} border-2 ${border} rounded-sm p-6 print:shadow-none shadow-hard`} data-testid="pass-card">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className={`overline ${muted}`}>{subtitle || 'Industrial Gate Pass'}</div>
          <div className={`heading font-black text-2xl ${text} mt-0.5`}>{title}</div>
        </div>
        <div className="text-right">
          <div className={`overline ${muted}`}>Pass ID</div>
          <div className={`font-mono text-sm font-bold ${text}`}>{passId}</div>
        </div>
      </div>

      <div className="grid grid-cols-[1fr_auto] gap-6 items-center">
        <div className="space-y-2">
          {lines.map((l, i) => (
            <div key={i} className="flex items-baseline gap-2 text-sm">
              <span className={`overline ${muted} w-24 flex-shrink-0`}>{l.label}</span>
              <span className={`font-semibold ${text}`}>{l.value || '—'}</span>
            </div>
          ))}
        </div>
        <div className={`p-3 ${variant === 'dark' ? 'bg-white' : 'bg-white border-2 border-dashed border-zinc-300'} rounded-sm`}>
          <QRCodeSVG value={passId} size={120} level="M" includeMargin={false} />
        </div>
      </div>

      {passcode && (
        <div className={`mt-4 pt-4 border-t ${border} flex items-center justify-between`}>
          <div>
            <div className={`overline ${muted}`}>6-Digit Passcode</div>
            <div className={`heading font-black text-3xl tracking-[0.2em] ${text}`}>{passcode}</div>
          </div>
          {footer && <div>{footer}</div>}
        </div>
      )}
      {!passcode && footer && <div className="mt-4 pt-4 border-t border-dashed border-zinc-300">{footer}</div>}
    </div>
  );
}
